import { VAlert } from 'vuetify/lib/components/VAlert';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VAlert,{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_vm._v("\n    Aguarde un instante. Contactando con Servicio de Pago\n    "),_c(VProgressLinear,{attrs:{"indeterminate":"","color":"yellow darken-2"}})],1),_vm._m(0),_c('div',[_vm._v(_vm._s(_vm.promiseError))]),_vm._v("\n  "+_vm._s(this.empresaId == 1
      ? this.ParametrosGenerales.coinFormPublicKey
      : this.ParametrosGenerales.coinFormPublicKeyFinadi)+"\n")],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{attrs:{"id":"myPaymentForm"}})])
}]

export { render, staticRenderFns }